import { FunctionComponent } from 'react';
import { XCircleIcon, CheckCircleIcon } from '@heroicons/react/24/solid';
import { Test } from '@playground/SQL/models/tests.model';
import { FormattedError } from './FormattedError';
import SyntaxErrors from './SyntaxErrors';

interface Props {
  test: Test;
}

const Test: FunctionComponent<Props> = ({ test }) => {
  return (
    <div className="w-full my-2">
      <p className="py-2 font-bold flex space-x-2 items-center">
        {test.status === 'fail' && (
          <XCircleIcon className="h-5 w-5 text-red-500" aria-hidden="true" />
        )}
        {test.status === 'pass' && (
          <CheckCircleIcon className="h-5 w-5 text-green-500" aria-hidden="true" />
        )}
        <span className="w-[calc(100%-1.25rem)] overflow-hidden break-words">{test.name}</span>
      </p>
      {test.status === 'fail' && (
        <>
          <SyntaxErrors syntaxErrors={test.syntaxErrors} />
          {test.errors.map((error) => (
            <div className="text-red-300 text-xs" key={`test-${error}`}>
              <FormattedError error={error} />
            </div>
          ))}
        </>
      )}
    </div>
  );
};

export default Test;
